import React, { useEffect, useState } from 'react';
import CustomInput from '../../components/CustomInput';
import '../../assets/css/SignUp.css';
import CustomButton from '../../components/CustomButton';
import loginImage from '../../assets/images/tennis-court.jpg';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomDatePicker from '../../components/CustomDatePicker';
import { NavLink, useNavigate } from 'react-router-dom';
import { apiHandler } from '../../assets/api';
import { endpoint } from '../../assets/api/endpoint';
import { RxCross2 } from "react-icons/rx";
import { format } from "date-fns";


const SignUp = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    dateOfBirth: '',
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    password: '',
    confirmPassword: '',
    parentEmail: '',
    parentPhoneNumber: '',
  });
  const [errors, setErrors] = useState({});
  const [isChecked, setIsChecked] = useState(false);
  const [config, setConfig] = useState();

  const calculateAge = (dob) => {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const validateField = (name, value) => {
    let newError = '';

    switch (name) {
      case 'firstName':
        if (!value) newError = 'First Name is required';
        break;
      case 'lastName':
        if (!value) newError = 'Last Name is required';
        break;
      case 'email':
        if (!value) newError = 'Email is required';
        else if (!/^\S+@\S+\.\S+$/.test(value)) newError = 'Invalid email format';
        break;
      case 'phoneNumber':
        if (!value) newError = 'Phone Number is required';
        else if (!/^\d{10}$/.test(value)) newError = 'Mobile number must be 10 digits';
        break;
      case 'password':
        if (!value) {
          newError = 'Password is required';
        } else if (value.length < 8) {
          newError = 'Password must be at least 8 characters long';
        } else if (!/[A-Z]/.test(value)) {
          newError = 'Password must contain at least one uppercase letter';
        } else if (!/[a-z]/.test(value)) {
          newError = 'Password must contain at least one lowercase letter';
        } else if (!/[0-9]/.test(value)) {
          newError = 'Password must contain at least one digit';
        } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
          newError = 'Password must contain at least one special character';
        }
        break;

      case 'confirmPassword':
        if (value !== formData.password) newError = 'Passwords do not match';
        break;
      case 'parentEmail':
      case 'parentPhoneNumber':
        const age = calculateAge(formData.dateOfBirth);
        if (age >= 13 && age < 18) {
          if (!formData.parentEmail && !formData.parentPhoneNumber) {
            newError = "Parent's email or phone number is required for users under 18 years";
          }
        }
        break;
      default:
        break;
    }

    setErrors(prev => ({ ...prev, [name]: newError }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    validateField(name, value);
  };

  const handleDOBChange = (date) => {
    const age = calculateAge(date);
    setFormData(prev => ({ ...prev, dateOfBirth: date }));

    if (!date) {
      setErrors(prev => ({ ...prev, dateOfBirth: 'Date of Birth is required' }));
    } else if (age < 10) {
      setErrors(prev => ({ ...prev, dateOfBirth: 'You must be at least 13 years old to register' }));
    } else {
      setErrors(prev => ({ ...prev, dateOfBirth: '' }));
    }
  };

 const validateFields = () => {
  const newErrors = {};

  Object.keys(formData).forEach((field) => {
    let value = formData[field];

    switch (field) {
      case 'firstName':
        if (!value) newErrors.firstName = 'First Name is required';
        break;
      case 'lastName':
        if (!value) newErrors.lastName = 'Last Name is required';
        break;
      case 'email':
        if (!value) newErrors.email = 'Email is required';
        else if (!/^\S+@\S+\.\S+$/.test(value)) newErrors.email = 'Invalid email format';
        break;
      case 'phoneNumber':
        if (!value) newErrors.phoneNumber = 'Phone Number is required';
        else if (!/^\d{10}$/.test(value)) newErrors.phoneNumber = 'Mobile number must be 10 digits';
        break;
      case 'password':
        if (!value) {
          newErrors.password = 'Password is required';
        } else if (value.length < 8) {
          newErrors.password = 'Password must be at least 8 characters long';
        } else if (!/[A-Z]/.test(value)) {
          newErrors.password = 'Password must contain at least one uppercase letter';
        } else if (!/[a-z]/.test(value)) {
          newErrors.password = 'Password must contain at least one lowercase letter';
        } else if (!/[0-9]/.test(value)) {
          newErrors.password = 'Password must contain at least one digit';
        } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
          newErrors.password = 'Password must contain at least one special character';
        }
        break;
      case 'confirmPassword':
        if (value !== formData.password) {
          newErrors.confirmPassword = 'Passwords do not match';
        }
        break;
      default:
        break;
    }
  });

  const age = calculateAge(formData.dateOfBirth);

  if (!formData.dateOfBirth) {
    newErrors.dateOfBirth = 'Date of Birth is required';
  } else if (age < 13) {
    newErrors.dateOfBirth = "You must be at least 13 years old to register";
  }

  if (age >= 13 && age < 18 && !formData.parentEmail && !formData.parentPhoneNumber) {
    newErrors.parentEmail = "Parent's email or phone number is required";
    newErrors.parentPhoneNumber = "Parent's email or phone number is required";
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};


  function formatToYYMMDD(isoString) {
    const date = new Date(isoString);
    const yy = String(date.getFullYear());
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yy}-${mm}-${dd}`;
  }

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    if (!validateFields()) return;
    const data = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      dateOfBirth: formatToYYMMDD(formData?.dateOfBirth),
      email: formData.email,
      mobileNumber: formData.phoneNumber,
      password: formData.password,
      checked: isChecked,
      guardianEmail: formData.parentEmail
    };

    try {
      const result = await apiHandler({
        url: endpoint.SIGN_UP,
        method: "POST",
        data: data,
      });
      if ((result?.data?.message) && (result?.data?.code !== 500)) {
        toast.success(result.data.message);
        navigate('/signupconfirmcode', { state: { email: formData.email, guardianEmail: formData.parentEmail } });
      } else {
        toast.error(result?.data?.user_description);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || error.message || "An unexpected error occurred.");
    }
  };

  const onSignIn = () => {
    navigate('/login')
  }

  const fetchConfiguration = async () => {
    try {
      const result = await apiHandler({
        url: endpoint.FETCH_CONFIG,
        method: "GET",
      });
      const fetchedDetail = result?.data || [];
      setConfig(fetchedDetail)
      // dispatch(saveConfiguration(fetchedDetail));
    } catch (error) {
      // toast.error(error.response?.data?.message || error.message || "An unexpected error occurred.");
    }
  };
  useEffect(() => {
    fetchConfiguration()
  }, [])

  return (
    <div className='container-sign-up-container' >
      <div className='sign-up-image-mobile'>
      </div>
      <div className="d-flex justify-content-center wrapper-sign-up-container " style={{ minHeight: '100vh' }}>
        <div className="col-lg-6 col-sm-12 sign-up-container wrapper-sign-up " style={{ margin: '15px' }}>
          <div className='pt-3'>
            <div className="text-start fw-bolder fs-4 sign-up-text" style={{ paddingBottom: '16px' }}>Register</div>
            <div className="text-muted fw-normal fs-6 lh-sm text-start">
              Create an account to get started
            </div>
            <form onSubmit={handleSubmit}>
              <div className='row'>
                <div className='mt-3 col-lg-12 dateName text-left'>
                  <div className='signup-datepicker' >
                    <DatePicker
                      selected={formData.dateOfBirth}
                      onChange={handleDOBChange}
                      customInput={
                        <CustomDatePicker
                          isInvalid={!!errors.dateOfBirth}
                          placehold="Date Of Birth"
                          label="Date Of Birth"
                          value={
                            formData.dateOfBirth
                              ? format(formData.dateOfBirth, "MMMM d, yyyy")
                              : ""
                          }
                          className={`${errors.dateOfBirth ? "is-invalid" : ""}`}
                        />
                      }
                      dateFormat="MMMM d, yyyy"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      wrapperClassName="date-picker-wrapper"
                    />
                    {errors.dateOfBirth && <div className="text-danger">{errors.dateOfBirth}</div>}
                  </div>
                </div>

                {calculateAge(formData.dateOfBirth) >= 13 &&
                  calculateAge(formData.dateOfBirth) < 18 && (
                    <>
                      <div className='mt-3 col-lg-6'>
                        <CustomInput
                          label="Parent's Email"
                          name="parentEmail"
                          className={`form-control ${errors.parentEmail ? 'is-invalid' : ''}`}
                          placeholder="Parent's Email"
                          type="email"
                          value={formData.parentEmail}
                          onChange={handleInputChange}
                        />
                        {errors.parentEmail && <div className="text-danger">{errors.parentEmail}</div>}
                      </div>
                      <div className='mt-3 col-lg-6'>
                        <CustomInput
                          label="Parent's Phone Number"
                          name="parentPhoneNumber"
                          placeholder="Parent's Phone Number"
                          className={`form-control ${errors.parentPhoneNumber ? 'is-invalid' : ''}`}
                          type="number"
                          value={formData.parentPhoneNumber}
                          onChange={handleInputChange}
                        />
                        {errors.parentPhoneNumber && <div className="text-danger">{errors.parentPhoneNumber}</div>}
                      </div>
                    </>
                  )}

                {[
                  { name: 'firstName', label: 'First Name ', placeHolder: 'First Name ', type: 'text' },
                  { name: 'lastName', label: 'Last Name ', placeHolder: 'Last Name ', type: 'text' },
                  { name: 'email', label: 'Email ', placeHolder: 'Email ', type: 'email' },
                  { name: 'phoneNumber', label: 'Phone Number ', placeHolder: 'Phone Number', type: 'number' },
                  { name: 'password', label: 'Password ', placeHolder: 'password ', type: 'password' },
                  { name: 'confirmPassword', label: 'Confirm Password', placeHolder: 'confirm password ', type: 'password' },
                ].map((field, i) => (
                  <div key={field.name} className='mt-3 col-lg-6'>
                    <CustomInput
                      label={field.label}
                      name={field.name}
                      placeholder={field.placeHolder}
                      type={field.type}
                      className={`form-control ${errors[field.name] ? 'is-invalid' : ''}`}
                      value={formData[field.name]}
                      onChange={handleInputChange}
                    />
                    {errors[field.name] && <div className="text-danger">{errors[field.name]}</div>}
                  </div>
                ))}

                <div className='d-flex pt-4'>
                  <input
                    type="checkbox"
                    className="sign-up-condition-checkbox"
                    checked={isChecked}
                    onChange={() => setIsChecked(!isChecked)}
                  />
                  <div className='sign-up-condition-checkbox-txt'>
                    I've read and agree with the
                    <span className='sign-up-condition-checkbox-txt-span' >
                      <a
                        href={`${endpoint.BASE_URL_STAGING}/public/images/${config?.termsAndConditionFile}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'none' }}
                      >
                        Terms and Conditions
                      </a>
                    </span> and the
                    <span className='sign-up-condition-checkbox-txt-span' >
                      <a
                        href={`${endpoint.BASE_URL_STAGING}/public/images/${config?.privacyPolicyFile}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className=''
                        style={{ textDecoration: 'none' }}
                      >
                        Privacy Policy.
                      </a>
                    </span>

                  </div>
                </div>

                <div className="signUp-button-container text-center">
                  <CustomButton
                    buttonText="Submit"
                    className={`${!isChecked ? 'disabled' : ''}`}
                    style={{
                      width: '327px',
                      height: '48px',
                      borderRadius: '12px',
                      background: '#4285f4',
                      color: '#FFFFFF',
                      border: 'none',
                    }}
                    type="submit"
                    disabled={!isChecked}
                  />
                </div>
                <div className='text-center' style={{ fontSize: '16px', marginTop: '23px' }}>Already have account <span className='sign-in-txt' onClick={onSignIn}> Sign In </span></div>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
